import { axiosDS } from '@pp/axios'
import { UnblockRequestStatusModel } from 'Pages/orders'
import { RequestParams } from 'Models'
import { urls } from 'Src/constants/Urls'

export const unblockRequestStatusesApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<UnblockRequestStatusModel[]>(
			`${urls.orders.unblockRequestStatuses}`,
			{
				params,
			}
		)
		return res.data
	},
}
